import { injectable } from 'tsyringe';
import { ExtensionConfig, ExtensionContext } from "./models/extension-config";

export abstract class Module {

    protected constructor(public dependantModules: Module[]) { }
    public abstract name: string;
    public abstract acceptedLicenseFlags: string[];
    public abstract shouldRun(context: ExtensionContext): boolean;
    public abstract run(): Promise<void>;
    
}